import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'workflows',
});

export const workflowsCreateRouteRef = createSubRouteRef({
  id: 'workflows_create',
  parent: rootRouteRef,
  path: '/create',
});

export const workflowsDetailsRouteRef = createSubRouteRef({
  id: 'workflows_detail',
  parent: rootRouteRef,
  path: '/:organisation/:workflow_name',
});

export const workflowsRevisionViewRouteRef = createSubRouteRef({
  id: 'workflows_revision_view',
  parent: rootRouteRef,
  path: '/:organisation/:workflow_name/revision/:revision',
});

export const workflowsRevisionsRouteRef = createSubRouteRef({
  id: 'workflows_revisions',
  parent: rootRouteRef,
  path: '/:organisation/:workflow_name/revisions',
});

export const workflowsRevisionCompareRouteRef = createSubRouteRef({
  id: 'workflows_revision_compare',
  parent: rootRouteRef,
  path: '/:organisation/:workflow_name/revisions/:revision1/:revision2',
});
